import React from 'react';

import { useGetFile } from '@vlabs/api/point-api/client';
import type { FileId } from '@vlabs/api/point-api/model';
import { FileIcon } from '@vlabs/icons';
import { TruncatedText } from '@vlabs/shared/components/truncated-text/TruncatedText';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import st from './FileItem.module.sass';
import type { BaseDataItemProps } from '../base-data-item';
import { BaseDataItem } from '../base-data-item';

export interface FileItemProps extends Omit<BaseDataItemProps, 'title'> {
  fileId?: FileId;
}

const displayName = 'FileItem';
const testid = buildTestid(displayName);

export function FileItem({
  fileId = undefined,
  actions = undefined,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: FileItemProps): React.JSX.Element | null {
  const getFile = useGetFile(fileId ?? '', undefined, {
    query: { enabled: !!fileId },
  });

  if (!fileId || !getFile.data?.filename) return null;

  return (
    <BaseDataItem
      actions={actions}
      className={className}
      title={(
        <React.Fragment>
          <div>
            <FileIcon className={st.Icon} />
          </div>
          <TruncatedText
            hasTruncation
            tooltipContent={getFile.data?.filename}
          >
            {getFile.data?.filename}
          </TruncatedText>

        </React.Fragment>
      )}
      {...testid(fileId, dataTestId)}
    />
  );
}
